/*
import React from 'react';
import { Col, Progress } from 'reactstrap';

export const CardDetalles = ({ data = {}, darkTheme }) => {

    const capitalize = (text) => {
        if (typeof text === 'string' && text.length > 0) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        } else {
            return text;
        }
    }

    const handleColor = (activated, calif) => {
        if (activated) {
            if (calif <= 60) {
                return "danger";
            } else if (calif >= 60 && calif < 75) {
                return "warning";
            } else {
                return "success";
            }
        } else {
            return "success";
        }
    }


    return (

        
        <Col xs="12" md="6">
            <div className={(darkTheme) ? "card margin-primary bg-dark-secondary" : "card margin-primary"}>
                <div>
                    <span className="name">{capitalize(data.meta.nombreActividad)}</span>
                    <span className="calif">{data.meta.calificacion}</span>
                </div>
                <div>
                    <Progress color={handleColor(false, data.meta.calificacion)} value={data.meta.calificacion} />
                </div>
            </div>
        </Col>
    )
}
    */

// CardDetalles.js

import React from 'react';
import { Col, Progress } from 'reactstrap';

export const CardDetalles = ({ data = {}, darkTheme }) => {

    const capitalize = (text) => {
        if (typeof text === 'string' && text.length > 0) {
            // --- INICIO DEL CAMBIO ---
            // Lista de siglas que deben permanecer en mayúsculas
            const siglasNoCapitalizar = ["SC", "NC"]; 
            
            // Si el texto es una de las siglas, se devuelve en mayúsculas y se evita la capitalización.
            if (siglasNoCapitalizar.includes(text.toUpperCase())) {
                return text.toUpperCase();
            }
            // --- FIN DEL CAMBIO ---

            // Lógica original para capitalizar palabras (ej. "examen" -> "Examen")
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        } else {
            return text;
        }
    }

    const handleColor = (activated, calif) => {
        if (activated) {
            if (calif <= 60) {
                return "danger";
            } else if (calif >= 60 && calif < 75) {
                return "warning";
            } else {
                return "success";
            }
        } else {
            // Este valor siempre es 'success' porque se llama con handleColor(false, ...)
            return "success"; 
        }
    }

    return (
        <Col xs="12" md="6">
            <div className={(darkTheme) ? "card margin-primary bg-dark-secondary" : "card margin-primary"}>
                <div>
                    {/* Aquí se aplica la función capitalize, ahora segura para "SC" */}
                    <span className="name">{capitalize(data.meta.nombreActividad)}</span>
                    <span className="calif">{data.meta.calificacion}</span>
                </div>
                <div>
                    <Progress color={handleColor(false, data.meta.calificacion)} value={data.meta.calificacion} />
                </div>
            </div>
        </Col>
    )
}
